export const mountableSteps = {
	title: "Producto montable",
	description:
		"Los productos montables permiten que el cliente final haga una combinación a partir de una base fija y una variedad de ingredientes adicionales. En el caso del açaí, por ejemplo, la base sería el açaí batido y los ingredientes adicionales serían paçoca, leche en polvo, etc.",
	stepLabel: "Paso",
	addStep: "Paso",
	removeStep: "Eliminar paso",
	fields: {
		title: {
			label: "Título",
			placeholder: "Ingrese el título del paso",
		},
		pricing: {
			label: "Precios",
			placeholder: "Elija un método",
			options: {
				sum: {
					label: "Adicional",
					tooltip: "Todo elemento agregado será incrementado en el valor del producto",
				},
				average: {
					label: "Promedio",
					tooltip: "El promedio de los elementos seleccionados será incrementado",
				},
				higher: {
					label: "Mayor valor",
					tooltip:
						"El mayor valor entre los elementos será agregado al valor del producto",
				},
			},
		},
		min: {
			label: "Valor mínimo",
			tooltip: "Mínimo de artículos a seleccionar",
		},
		max: {
			label: "Valor máximo",
			tooltip: "Máximo de artículos a seleccionar",
		},
	},
	itemsSection: {
		title: "INGREDIENTES ADICIONALES",
		addItem: "Agregar otro artículo",
		removeItem: "Eliminar artículo",
		fields: {
			item: {
				label: "Artículo",
				placeholder: "Seleccione un artículo",
				loadingPlaceholder: "Cargando productos...",
			},
			price: {
				label: "Precio",
			},
			maxCount: {
				label: "Cantidad máxima seleccionable",
				placeholder: "Ingrese la cantidad",
				tooltip:
					"Número máximo de veces que este artículo puede seleccionarse en la sección",
			},
			storageCount: {
				label: "Cantidad descontada",
				placeholder: "0",
				tooltip: "Cantidad que se descontará del stock por unidad",
			},
			isModification: {
				label: "Artículo de modificación",
			},
		},
	},
};
